let contentText = `
1、本条款的缔约主体是您与京递快运（以下简称京递）。请您认真阅读本条款，您使用京递服务表明您已充分阅读、理解并接受本条款的部内容，并确认您因工作需要使用本服务时，您已充分获得您工作单位的授权。

2、您确认，京递将托寄物送达收件人地址，经收件人或收件人（寄件人）允许的代收人签收，视为送达。若无收件人姓名，仅有收件地址，则由收件地址收件人员签收，或盖位收发章，视为送达。您或您的委托人对托寄物进行签收即表明您确认京递已经按照《电子运单契约条款》履行完毕合同义务。如您是月结客户，本条款的约定与您签署的《收派服务合同》的约定不一致的，适用本条款的约定。

3、本条款履行过程中如发生争议，双方应友好协商解决。如协商不成的，应向寄件地有管辖权的人民法院提起诉讼。

4、您同意遵守京递官方网站所公示的隐私政策及其不时修订的内容，同意京递按照法律法规和隐私政策的规定处理您提供的运单信息。

5、保价与赔偿

	您理解并认同，京递是按托寄物的计费重量收取运费，并非按托寄物的价值和预期收益收取运费，同时京递为您的托寄物提供保价服务，您可根据托寄物的实际价值和赔偿需求，自行评估是否投保。同时，您理解并认同，保价服务的选择与否对于托寄物毁损、灭失之后的赔付标准具有非常重要的意义，您同意以下
	保价与理赔规则：

	5.1保价

	5.1.1京递提供的保价服务，系基于您的保价金额收取费用，对于物品价值超过1000元的贵重物品建议您选择保价服务，并遵循诚实信用的原则如实按照托寄物实际价值进行保价保费按照保价金额的一定比例收取，具体收取比例以京递官方渠道公示为准。

	5.1.2京递对部分价值 不易核实、易破损等物品不提供保价服务，详细规则请见保价界面。

	5.1.3 为节约您的寄件时间，京递对托寄物价值采取“理赔审查”的方式，包括：

		1）您应在寄件时如实按照托寄物的实际价值填写保价金额；
		2）您应在理赔时提供托寄物的真实有效价值证明（如发票，合同、付款凭证组合）和按京递要求提供相关资料（如可见运单号的外包装、内包装和托寄物损坏图片，损坏物品放在快件运单旁边拍照等）井主动说明损失托寄物情况;
		3) 如您寄递一票多件，托寄物相同，发生部分托寄物丢失或损坏，根据保价金额除以物品总数量计算单个托寄物的保价金额;托寄物不同，发生部分托寄物丢失或损坏，根据各托寄物的保价金额计算单个托寄物的保价金额，再结合下述5.2条约定的赔偿服务处理，如您认为该赔偿标准不足以弥补您的损失，京递建议对贵重物品单独寄递和保价。
		4）如双方对实际价值有争议的，京递会结合市场价值和第三方评估机构出具的损失价值，基于本协议的约定对您进行赔偿，但本协议另有约定的除外。

	5.2赔偿

	5.2.1因京递原因造成托寄物毀损、灭失的，结合您是否购买保价服务及购买的保价服务的类型进行赔偿，该赔偿不包括您基于托寄物可能获得的收益、利润、实际用途、商业机会、商业价值等任何问接损失。

	1 ）若您选择“基础保”，京递将按照保价金额和托寄物实际损失（损坏时为维修费）比例向您赔偿．最高不超过托寄物的实际损失金额。托寄物不足额保价的部分或超额保价的部分均无法获得赔偿。

	2） 若您选择“足额保”增值服务且支付保价费用的，足额投保情况下，托寄物出现全部丢失或损坏 (含无法维修）的情况下，根据实际损失金额进行全额赔偿，最高不超过保价金额;在托寄物出现部分损坏的情况下，如托寄物可维修，赔付维修费用，如托寄物无需维修，按照保价金额和损坏程度进行赔偿，最高不超过保价金额。

	3) 若您选择“定额保”在托寄物出现全部毁损的情况下，京递根据您的保价金额进行赔偿，在托寄物出现部分毁损的情况下，京递按50%保价金额固定比例赔偿。

	特别说明：①请您遵循诚实信用的原则，按托寄物的实际价值进行保价，若保价金额高于托寄物实际价值的，京递赔付最高不超过托寄物的实际价值。

	②详细的保价服务内容、收费标准及理赔规则等可见京递官网公示的理赔说明。

	5.2.2若您未购买保价服务或京递不提供保价但发生托寄物灭失、破损或短少时，京递按照下述约定承担赔偿责任：

	1） 当您寄递非生鲜件托寄物，若在运输环节发生灭失、破损、短少的，京递在7倍运费限额内向您赔偿托寄物的实际损失，最高上限为1000元，双方另有约定的除外;

	2） 当您寄递生鲜类托寄物，若在运输环节发生失活、破损、短少的，京递在7倍运费限额内向您赔偿托寄物的实际损失，最高上限为500元，双方另有约定的除外；

	3） 当您选择京递卡航、大票直送等速运产品，若在运输环节发生灭失、破损、短少的，京递在5倍运费的限额内向您赔偿托寄物的实际损失，最高上限为1000元，双方另有约定的除外；

	4) 当您选择整车直达速运产品，若在运输环节发生灭失、破损、短少的，京递在1倍运费的限额内向您赔偿托寄物的实际损失，最高上限为1000元，双方另有约定的除外;

	5）如您认为未保价的赔偿标准不足以弥补您的损失，您应根据托寄物的实际价值选择等值的保价服务。

	说明：京递不提供保价服务的托寄物，详见各类保价服务的理赔说明。

	5.2.3每票托寄物只能提出一次索赔，且与该托寄物相关的所有损失或损坏的赔偿是完全并最终的。

	5.2.4京递对托寄物按照本协议的约定及保价服务的理赔说明赔付后，托寄物尚有残值的，归京递所有，如托寄物归您所有，京递有权在赔偿金额中扣减托寄物残值后再向您赔付。

	5.2.5 若您或指定付款人尚末支付所有快件服务费用，京递无义务受理任何索赔，如拒绝支付保价费用的，京递将按照未保价托寄物进行赔偿。

	5.2.6若您选择签单返还服务时，因京递原因导致签收回单破损、灭失的，京递承担的责任仅限于免费提供一次签单返还服务作为赔偿。

	5.2.7因京递与保险公司针对托寄物存在合作投保的情况，如托寄物出现损坏、遗失等异常状况时，可能由该等保险公司直接负责相关的理赔事宜。为保障您的个人权益，您的件信息、托寄物信息等个人信息将会同步至与京递合作的保险公司，并由该等保险公司处理您的托寄物理赔事宜。如悠签订本协议，即视为同意京递将您的上述个人信息同步至与京递合作的保险公司并同意由该等保险公司用于处理托寄物理赔事宜。

	5.3特别提醒您注意，发生以下情形之一的京递无须承担赔偿责任

	5.3.1因不可抗力的原因或政府管控行为、决定或命令等导致托寄物灭失、破损、短少、延误的（保价件除外）。

	5.3.2 购买足额保和定额保产品服务，快件派送时当面签收但未反馈异常的。

	5.3.3生鲜、冷冻类等易腐或需温控物品已签收，但您在签收后超过48小时反馈腐烂变质等破损问题的。

	5.3.4生鲜、冷冻类等易腐或需温控物品在京递官网展示的预计送达时效内送达，但送达时腐烂变质的。

	5.3.5因您或收件人过失以及托寄物物品自身原因（包括但不限于托寄物自身属性、内在缺陷或合理损耗及与运单信息填写错误或不全等）造成托寄物损失或延误的。

	5.3.6外包装无明显异常，而内件短少或毁损，签收人签收时未提出异议的（包括但不限于京递无法拆开托寄物原销售包装进行内包装加固，或您自备的托寄物包装不良但外部无法发现;或托寄物从表面查看无法发现损坏但通电后，出现无法开机，黑屏等场景）。

	5.3.7代收货款件，因收寄双方发生买卖纠纷导致收件人对托奇物采取保全措施（如扣留托寄物）而造成的损失等。

	5.3.8非京递过错导致您损失的，包括但不限于您没有如实申报托寄物资料，或您寄递的物品违反禁寄或限寄规定，被国家行政机关没收或依照有关法律法规处理的。

	5.3.9当托寄物为医学检测类物品时（如血液、唾液、人体组织液、尿液、粪便等），您承诺该医学检测类物品不会被用于非法途径（如：胎儿性别鉴定等）。由于医学检测类寄物本身不属于用于销售的产品，没有销售价值。故医学检测类托寄物发生损坏、丢失，京递在7倍运费限额内向您赔偿托寄物的实际损失，双方另有约定的除外。

	5.3.10如您与京递签订《特定托寄物赔付标准协议》 等协议或有其他法律规定的，以相关约定的为准。

	5.4托寄物延误的赔偿仅为免除当次运费（不含保价费等附加费用）。

	5.5理赔申报时间及反馈渠道：托寄物如有发生损坏或遗失，应当在托寄物签收后48小时内通过京递相关渠道(包括但不限于京递快运小程序、京递快运微信公众号、京递快运APP或京递月结管家等）反馈索赔诉求。

5.6 特殊场景下的应对方式：

	您确认，因不可抗力或政府管控行为、决定或命令导致易腐损物品（如生鲜食品、时令水果、鲜花等）出现下列场景时，应当按下述约定进行操作应对：

	5.6.1因上述原因导致托寄物无法继续中转的，双方将积极沟通，为避免扩大损失，京递有权结合实际情况决定安排退回。

	5.6.2因上述原因导致托寄物停滞时间超7天仍无法发运的，京递有权结合实际情况对托寄物按作废处理。

6、为保证托寄物安全送达，您在寄件时应履行以下义务：

	6.1确保托寄物不包含国家机关公文、国家保护野生动物和濒危野生动物及其制品、假冒伪劣和侵权物品等法律法规禁止和限制寄递的物品，不得通过寄递渠道危害国家安全、共安全和公民、法人、其他组织的合法权益。

	6.2出示有效身份证件，配合京递工作人员进行身份查验、身份信息登记，如果您是受他人委托寄件，还应当提供委托人的有效身份证件。

	6.3配合进行开箱验视，托寄物需要办理审批、检验等手续的，您应提交办理完相关手续的证明文件。京递可以对托寄物内件拍照取证，如发现禁止或限制寄递的物品，有权移交相关部门处理。

	6.4如实申报托寄物的名称、性质、数量和价值，并准确填写寄件人、收件人的名称、地址、联系电话等信息。

	6.5根据托寄物的性质(尤其是易损易碎、易腐蚀、昮泄漏的液体或其他），您应根据托寄物的性质提供充分的防破损、防漏、防爆措施，保障安全运输。

7、京递的义务

	7.1出于安全及法律法规的要求，京递有权对托寄物进行当场开箱验视及安全监测。免生疑问，京递不会对因上述检查而导致的任何延误造成的损失负责。对禁寄及拒绝验视的寄物不予收寄。

	7.2京递向寄件人提供自交寄之日起一年内的查询服务。

8、京递为保护您的个人信息，可能会使用封密运单。京递会对您寄件时在下单系统录入的信息予以保存。对于保密运单所隐匿的信息，您同意以京递系统所查询的内容为准。

9、您的违约赔偿责任

	9.1因托寄物有安全隐患、质量缺陷或包装破损，致使其他托寄物、运输工具、机械设备被污染腐蚀、损坏，或造成人身伤亡的，您应承担赔偿责任。

	9.2因托寄物属于或含有禁止或限制寄递物品而被查没、扣留或变更配送路线，导致其他托寄物时效延误或价值丧失，给京递或第三人造成经济损失的，您应承担赔偿责任。

	9.3因您违反第6条的义务导致京递或第三人承担行政处罚、民事赔偿等所造成的各项经济损失，您应承担赔偿责任。

	9.4若京递发现您违背诚实信用原则，通过虛构事实、提供虛假材料（包含且不限于价值证明、损坏照片等）或其它不正当手段申请理赔或骗取其它权益的，京递将采取下述种或多种措施：

	9.4.1 京递拒绝受理理赔事项及/或承担赔偿责任，且无须承担违约责任；

	9.4.2 京递停止为您提供寄递服务、且无须承担违约责任；

	9.4.3 对于您已获取的不当得利，京递能有杈追回且保留追究您相应责任的权利，情节严重的，京递将移交相关部门处理。

10、留置杈

	10.1如您选择的是速运产品，您或您指定的付款人未付清费用的，京递有权留置托寄物，留置后您的债务履行期限为 2个月（自揽收托寄物之日起计算），但托寄物性质不能留的除外。债务履行期限届满，您或指定付款人仍未付清费用的，京递可以变卖、拍卖留置物并优先受偿。变卖、拍卖所得价款应优先支付京递为行使留置权所支出的费用和保费，再偿付拖欠京递的费用；如有余额，可根据您的要求汇至您指定账户。

	10.2如您选择的是速运产品，您或您指定的付款人未付清费用的，京递将与您联系获取处理意见（包括但不限于放弃托寄物所有权、退回、销毁等），您应在规定时间内予以复，如因您无法联系、未在规定时间内回复等造成托寄物滞留，自京递通知之日(指京递客服、短信、官网路由提示或展示的节点异常之日，若有多个节点异常，则以第一个节异常之日为准）起超过30个自然日的，视为您放弃对托寄物的所有权，京递有权对托寄物进行处理，产生的处理费用由您承担。针对京递己成功联系您但上门派送失败、或已到自取点并成功发送短信但您逾期未自取的托寄物，自首次通知次日起3个工作日内为免费保管期，从第4天开始收取托寄物保管服务费（派送当天不计入保管天数），收费标准按京递官方网站上所公示的收费标准收取。

11、关于费用的约定

	11.1您指示在物流中心、保税区等需要支付出/入仓费或其他额外费用的特殊地址收取或派送托寄物时，您或您指定付款人应当偿还京递垫付的上述出/入仓费等额外费用，并支付附加服务费，该等费用金额以京递取得的收费凭证为准。
	
	11.2春节等法定节假日和“双十一”等业务高峰期间您需要提供服务的，可能会加收附加服务费，该等费用以京递官网、公众号、APP等平台公示为准，您可以登陆京递官方网站拨打京递客服热线咨询。若您在价格变更后继续寄件，表示您同意按照变更后的价格支付费用。

	11.3若您要求退回，则双程费用均由您承担；若您对托寄物声明放弃的，您不可就该托寄物再向京递主张任何权利，您同意京递有权自行处置该托寄物，京递不对此承担任何任。

12、京递服务产品的时效说明以官方网站上所公示的解释为准，您可以登录官方网站查询或拨打京递客服热线咨询。

13、京递会以电话、电子邮件、手机短信等方式告知、发送的产品/业务介绍、推广促销信息及其他商业性信息。您不同意继续接收以上信息的，可以通过短信或拔打京递客服线方式退订。

14、如果本条款中的某条款被法院或政府机构认定为无效或部分无效，则双方同意除无效条款外仍应执行本合同其它条款，部分有效条款在其可执行的范围内仍继续执行。

`

export default contentText